import { getInitials } from '../lib/utils.js'

interface AvatarProps {
  name: string
  avatarUrl?: string | null
  size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-12 w-12 text-base',
}

export function Avatar({ name, avatarUrl, size = 'md' }: AvatarProps) {
  const classes = sizeClasses[size]

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={name}
        className={`${classes} rounded-full object-cover`}
      />
    )
  }

  return (
    <div
      className={`${classes} flex items-center justify-center rounded-full bg-(--color-primary) font-medium text-white`}
    >
      {getInitials(name)}
    </div>
  )
}
